import React from 'react';
import PropTypes from 'prop-types';

import { StyledBreadcrumb } from './style';
import { Container } from '../../gridSystem';

const Breadcrumb = ({ crumbs }) => (
  <Container className="pt-0">
    <StyledBreadcrumb>
      {crumbs.map((item, index) => (
        //? react fragment extended syntax needed to assign key
        <React.Fragment key={`item-${index}`}>
          <span
            onClick={item?.onClick}
            data-onclick={typeof item?.onClick === 'function'}
          >
            {item?.label}
          </span>

          {index < crumbs.length - 1 && (
            <svg
              width="8"
              height="16"
              viewBox="0 0 8 16"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path
                d="M0 15.2639L5.98425 0L8 0.757781L1.99475 16L0 15.2639Z"
                fill="#8B8B8B"
              />
            </svg>
          )}
        </React.Fragment>
      ))}
    </StyledBreadcrumb>
  </Container>
);

Breadcrumb.propTypes = {
  crumbs: PropTypes.array.isRequired,
};

export default Breadcrumb;
